import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { UPDATE_TICKET_STATUS, UPDATE_TICKET_STATUS_SUCCESS, UPDATE_TICKET_STATUS_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* updateTicketStatus({ payload }) {
  const { ticketId } = payload;
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/tickets/${ticketId}/transition`,
      method: 'POST',
      data: payload.data,
      isFormData: true,
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: UPDATE_TICKET_STATUS_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: UPDATE_TICKET_STATUS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_TICKET_STATUS_ERROR, payload: error });
  }
}

export function* watchupdateTicketStatus() {
  yield takeEvery(UPDATE_TICKET_STATUS, updateTicketStatus);
}

function* updateTicketStatusSaga() {
  yield all([fork(watchupdateTicketStatus)]);
}

export default updateTicketStatusSaga;
